import { render, staticRenderFns } from "./CategoryAndProducts.vue?vue&type=template&id=0b7a889d&scoped=true"
import script from "./CategoryAndProducts.vue?vue&type=script&lang=js"
export * from "./CategoryAndProducts.vue?vue&type=script&lang=js"
import style0 from "./CategoryAndProducts.vue?vue&type=style&index=0&id=0b7a889d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7a889d",
  null
  
)

export default component.exports